// TODO create semantic variants for text
const Text = {
  baseStyle: {
    fontSize: "body.s",
    color: "teal",
  },
  variants: {
    gray: {
      color: "gray.500",
    },
    heading: {
      color: "pureBlack",
      fontSize: "heading.xl",
    },
    rightSidebarLabel: {
      color: "gray.600",
      fontWeight: "normal",
    },
    rightSidebarValue: {
      fontWeight: "normal",
    },
    subtitle: {
      fontSize: "heading.l",
      fontWeight: "bold",
    },
    innerTitle: {
      fontSize: "body.s",
      fontWeight: "500",
    },
    statusTitle: {
      fontSize: "body.xs",
      fontWeight: "500",
      color: "darkTeal",
    },
    cardTitle: {
      fontSize: "bod.m",
      fontWeight: "700",
      color: "teal",
    },
  },
};

export default Text;
